import { DiscountCalculateWithCartRequestDto } from '@altermeliora/payform-types';
import { APIRequest } from './api-service/api-request';
import { ItemDiscount } from '../lib/common-interfaces';

export const checkPromocodeRequest = (params: DiscountCalculateWithCartRequestDto): Promise<ItemDiscount[]> => {
  const request = new APIRequest();
  return request.post(`${process.env.DISCOUNTS_API_URL}/calculate`, params);
};
